import { useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppKitAccount } from "@reown/appkit/react";
import { UserContext } from "../../provider/userprovider";
import allowlistIcon from "../../assets/icons/Allowlist-tab.png";
import "./index.scss";

const ALLOWLIST_URL = "https://fortunefoes.com/allowlist";

const ProfileGateOverlay = () => {
  const [searchParams] = useSearchParams();
  const { isConnected } = useAppKitAccount();
  const user = useContext(UserContext);

  const isLeaderboardTab = searchParams.get("tab") === "leaderboard";
  const { isTwitterConnected, isDiscordConnected, isLogin, dataloading } =
    user.userInfo;

  const show =
    !isLeaderboardTab &&
    (isConnected || isLogin) &&
    !dataloading &&
    !isTwitterConnected &&
    !isDiscordConnected;

  useEffect(() => {
    if (!show) return;

    document.documentElement.classList.add("wallet-gate-open");
    document.body.classList.add("wallet-gate-open");

    return () => {
      document.documentElement.classList.remove("wallet-gate-open");
      document.body.classList.remove("wallet-gate-open");
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      className="profile-gate-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="profile-gate-title"
    >
      <div className="profile-gate-overlay__content">
        <p id="profile-gate-title" className="profile-gate-overlay__title">
          Complete Your Profile Authentication To Participate
        </p>
        <button
          type="button"
          className="profile-gate-overlay__button"
          aria-label="Go to profile page"
          onClick={() => {
            window.location.href = ALLOWLIST_URL;
          }}
        >
          <span className="profile-gate-overlay__icon-wrap">
            <img
              src={allowlistIcon}
              alt=""
              className="profile-gate-overlay__icon"
              aria-hidden="true"
            />
          </span>
          <span className="profile-gate-overlay__button-text">
            <span className="profile-gate-overlay__button-text-profile shimmer-text">PROFILE</span>
            <span className="profile-gate-overlay__button-text-page">PAGE</span>
          </span>
        </button>
      </div>
    </div>
  );
};

export default ProfileGateOverlay;
